import PropTypes from "prop-types";
import classNames from "classnames";

const IconEmail = ({ className, height = "15px", width = "20px" }) => {
    const classes = classNames("emailIcon", className);

    return (
        <svg
            className={classes}
            width={width}
            height={height}
            viewBox="0 0 20 15"
            version="1.1"
            focusable="false"
            aria-hidden="true"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    transform="translate(-388.000000, -361.000000)"
                    fill="#246CFF"
                    fillRule="nonzero"
                >
                    <g transform="translate(388.000000, 361.000000)">
                        <path
                            d="M17.9190341,0 L1.85369318,0 C0.829913885,0 0,0.839453125 0,1.875 L0,13.125 C0,14.1605469 0.829913885,15 1.85369318,15 L17.9190341,15 C18.9428134,15 19.7727273,14.1605469 19.7727273,13.125 L19.7727273,1.875 C19.7727273,0.839453125 18.9428134,0 17.9190341,0 Z M17.9190341,1.875 L17.9190341,3.46894531 C17.0531277,4.1821875 15.6726669,5.29125 12.7214715,7.62871094 C12.0710955,8.14617187 10.7827788,9.38933594 9.88636364,9.37484375 C8.99010298,9.38949219 7.70136142,8.14597656 7.05125577,7.62871094 C4.10052379,5.29160156 2.71971547,4.18230469 1.85369318,3.46894531 L1.85369318,1.875 L17.9190341,1.875 Z M1.85369318,13.125 L1.85369318,5.87492187 C2.73859996,6.58785156 3.99351163,7.58828125 5.90625266,9.10328125 C6.75033958,9.77535156 8.22854403,11.2589844 9.88636364,11.2499609 C11.5360347,11.2589844 12.9955091,9.796875 13.866127,9.10359375 C15.7788295,7.58863281 17.0340887,6.58792969 17.9190341,5.87492187 L17.9190341,13.125 L1.85369318,13.125 Z"
                            id="Shape"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

IconEmail.propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
};

export default IconEmail;
